import { useDsTheme } from "@totalenergiescode/mobility-business-rev-design-system";

import Empty_State from "@/assets/animations/Empty-State.json";
import {
  StyledContent,
  StyledHighlightLeftCard,
  StyledLottie,
  StyledPlayer,
  StyledPrincipalText,
  StyledSecondText,
} from "@/components/shared/EmptyComponent/styles";

export const EmptyContent: React.FC<{
  principalText: string;
  secondaryText?: string;
  lottie?: object;
}> = ({ principalText, secondaryText, lottie }) => (
  <>
    <StyledLottie>
      <StyledPlayer autoplay loop src={lottie || Empty_State} />{" "}
    </StyledLottie>
    <StyledPrincipalText variant='title3'>{principalText}</StyledPrincipalText>
    {secondaryText ? (
      <StyledSecondText variant='text3'>{secondaryText}</StyledSecondText>
    ) : null}
  </>
);

export const EmptyDataInDB: React.FC<{
  principalText: string;
  secondaryText?: string;
  lottie?: object;
}> = ({ principalText, secondaryText, lottie }) => {
  const theme = useDsTheme();

  return (
    <StyledHighlightLeftCard highlightColor={theme.palette.primary[500] || ""}>
      <EmptyContent
        principalText={principalText}
        secondaryText={secondaryText}
        lottie={lottie}
      />
    </StyledHighlightLeftCard>
  );
};

export const EmptyDataForThisFilter: React.FC<{
  principalText: string;
  secondaryText?: string;
  lottie?: object;
}> = ({ principalText, secondaryText, lottie }) => (
  <StyledContent>
    <EmptyContent
      principalText={principalText}
      secondaryText={secondaryText}
      lottie={lottie}
    />
  </StyledContent>
);
